export default __webpack_public_path__ + "static/media/mei_technologies_contact_pic2.3c61ee63.PNG";